import React from 'react';
import styled from 'styled-components';
//
import { Link } from '@reach/router';
//
export default ({ children, title, to, ...rest }) => {
  if (!to) return children;

  if (/^https?:\/\//.test(to))
    return (
      <ExternalLink href={to} title={title} {...rest} target="_blank">
        {children}
      </ExternalLink>
    );

  return (
    <Link to={to} title={title} {...rest}>
      {children}
    </Link>
  );
};
//
const ExternalLink = styled.a``;
